import styled from 'styled-components';

import { TutorDisplayMode, TutorDraggingState } from './tutor.types';

export const StyledTutor = styled.div<{ $draggingState: TutorDraggingState }>`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 20;
  transition: ${({ $draggingState }) => ($draggingState === 'dragging' ? 'none' : 'all 0.5s ease-in-out')};
`;

export const StyledChatButtonWrapper = styled.div<{ $tutorOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  transform: translate(20px, -20px);
  opacity: ${({ $tutorOpen }) => ($tutorOpen ? '0' : '1')};
  transition: all 0.5s ease-in-out;
  z-index: 1001;

  user-select: none;
  -webkit-user-drag: none;

  img {
    pointer-events: none;
  }
`;

export const StyledWindowWrapper = styled.div<{
  $tutorOpen: boolean;
  $draggingState: TutorDraggingState;
  $displayMode: TutorDisplayMode;
  $width: number;
  $height: number;
}>`
  height: ${({ $tutorOpen, $height }) => ($tutorOpen ? `${$height}rem` : '0')};
  width: ${({ $tutorOpen, $width }) => ($tutorOpen ? `${$width}rem` : '5.2rem')};
  border-radius: ${({ $tutorOpen }) => ($tutorOpen ? '1.2rem' : '50%')};
  opacity: ${({ $tutorOpen }) => ($tutorOpen ? '1' : '0')};
  visibility: ${({ $tutorOpen }) => ($tutorOpen ? 'visible' : 'hidden')};
  transition: all 0.5s ease-in-out;
  position: fixed;
  bottom: 0;
  left: 0;
  transform: translate(20px, -20px);
  z-index: 1002;
  overflow: hidden;

  .tutor-drag-handle {
    cursor: ${({ $draggingState, $displayMode }) => {
      if ($draggingState === 'dragging') {
        return 'grabbing';
      }
      if ($displayMode === TutorDisplayMode.EMBEDDED) {
        return 'default';
      }
      return 'grab';
    }};
  }

  filter: ${({ $draggingState }) => ($draggingState === 'drag-start' ? 'contrast(85%) brightness(103%)' : 'none')};
  box-shadow: 0px 7.9px 26px 0px rgba(0, 0, 0, 0.6);
`;
